import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderMultiTextBox,
  renderInteger,
  renderMoney,
  renderExcludeInclude,
} from "./RenderUtils";

export class WcPayrollChangeRequest extends Component {
  render() {
    const { data: request, updateRequest, formRef } = this.props;

    return (
      <Form ref={formRef}>
        {renderMultiTextBox(
          "descriptionOfChange",
          "Description of Change",
          request,
          updateRequest
        )}
        {renderInteger(
          "newTotalNumberOfEmployees",
          "Total number of employees (do not include owners)",
          request,
          updateRequest,
          undefined,
          { ignoreServerValidation: true }
        )}
        {renderMoney(
          "newTotalAnnualEmployeePayroll",
          "Total annual employee payroll (do not include owners)",
          request,
          updateRequest,
          undefined,
          { ignoreServerValidation: true }
        )}
        {renderMultiTextBox(
          "newDutiesOfEmployees",
          "Please describe the duties of the employee(s)",
          request,
          updateRequest
        )}
        {renderMultiTextBox(
          "newEmployeeWorkLocation",
          "If there’s more than one location, at which location does the employee(s) work? (if only one location, please enter N/A)",
          request,
          updateRequest
        )}
        {renderInteger(
          "newTotalNumberOfExecutives",
          "Total number of executive officer/owners",
          request,
          updateRequest,
          undefined,
          { ignoreServerValidation: true }
        )}
        {renderInteger(
          "newPercentageOfOwnership",
          "Percentage of ownership",
          request,
          updateRequest,
          undefined,
          { ignoreServerValidation: true }
        )}
        {renderMoney(
          "newTotalAnnualExecutivePayroll",
          "Total annual payroll for the executive officer/owners",
          request,
          updateRequest
        )}
        {renderMultiTextBox(
          "newOwnerDutiesDescription",
          "Please describe the duties of the owner(s)",
          request,
          updateRequest
        )}
        {renderMultiTextBox(
          "newOwnerWorkLocation",
          "If there’s more than one location, at which location does this owner(s) work? (if only one location, please enter N/A)",
          request,
          updateRequest
        )}
        {renderExcludeInclude(
          "newIncludeOrExcludeOwner",
          "WC Only: Are we Excluding or Including the Owner(s)?",
          request,
          updateRequest
        )}
      </Form>
    );
  }
}
